var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-tab",class:{ active: _vm.active },on:{"click":_vm.tabClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }